import { ChartTypes } from '@mode/shared/contract-common';

const DEFAULT_CHART_TITLE = 'Chart';

export namespace ChartResFunctions {
  export const CHART_TYPE_ICONS = {
    bar: 'icon-chart-grouped-bar-gray',
    hBar: 'icon-chart-h-grouped-bar-gray',
    stackedBar: 'icon-chart-bar-gray',
    stackedBar100: 'icon-chart-bar-100-gray',
    hStackedBar: 'icon-chart-h-bar-gray',
    hStackedBar100: 'icon-chart-h-bar-100-gray',
    bigNumber: 'icon-chart-bignumber-gray',
    bigValue: 'icon-chart-bigvalue-gray',
    pivotTable: 'icon-chart-pivot-gray',
    linePlusBar: 'icon-chart-linebar-gray',
    line: 'icon-chart-line-gray',
    area: 'icon-chart-area-gray',
    totalArea: 'icon-chart-area100-gray',
    scatter: 'icon-chart-scatter-gray',
    pie: 'icon-chart-pie-gray',
    donut: 'icon-chart-donut-gray',
    table: 'icon-chart-table-gray',
    vegas: 'icon-chart-explorer',
  };

  export const CHART_TYPE_ICONS_DARK = {
    bar: 'icon-chart-grouped-bar-dark',
    hBar: 'icon-chart-h-grouped-bar-dark',
    stackedBar: 'icon-chart-bar-dark',
    stackedBar100: 'icon-chart-bar-100-dark',
    hStackedBar: 'icon-chart-h-bar-dark',
    hStackedBar100: 'icon-chart-h-bar-100-dark',
    bigNumber: 'icon-chart-bignumber-dark',
    bigValue: 'icon-chart-bigvalue-dark',
    pivotTable: 'icon-chart-pivot-table-new-dark',
    linePlusBar: 'icon-chart-linebar-dark',
    line: 'icon-chart-line-dark',
    area: 'icon-chart-area-dark',
    totalArea: 'icon-chart-area100-dark',
    scatter: 'icon-chart-scatter-dark',
    pie: 'icon-chart-pie-dark',
    donut: 'icon-chart-donut-dark',
    table: 'icon-chart-flat-table-dark',
    vegas: 'icon-chart-explorer',
  };

  export const CHART_COLOR_ICONS = {
    bar: 'icon-chart-grouped-bar-color',
    hBar: 'icon-chart-h-grouped-bar-color',
    stackedBar: 'icon-chart-bar-color',
    stackedBar100: 'icon-chart-bar-100-color',
    hStackedBar: 'icon-chart-h-bar-color',
    hStackedBar100: 'icon-chart-h-bar-100-color',
    bigNumber: 'icon-chart-bignumber-color',
    bigValue: 'icon-chart-bigvalue-color',
    pivotTable: 'icon-chart-pivot-color',
    linePlusBar: 'icon-chart-linebar-color',
    line: 'icon-chart-line-color',
    area: 'icon-chart-area-color',
    totalArea: 'icon-chart-area100-color',
    scatter: 'icon-chart-scatter-color',
    pie: 'icon-chart-pie-color',
    donut: 'icon-chart-donut-color',
    table: 'icon-chart-table-color',
    vegas: 'icon-chart-explorer',
  };

  export function getTitle(chart: ChartTypes.ChartResource) {
    return chart.view_version === 1 ? chart.view.chartTitle : chart.view_vegas.title;
  }

  export function getTitleOrDefault(chart: ChartTypes.ChartResource) {
    let type: string = chart.view_version === 1 ? chart.view.selectedChart : chart.view_vegas.chartType;
    let suffix = DEFAULT_CHART_TITLE;

    if ((chart.view.bar && chart.view.bar.stacked) || type === 'stackedBar') {
      type = 'Bar';
    } else if (type === 'bar') {
      type = 'Grouped Bar';
    } else if (type === 'hBar') {
      type = 'Grouped Bar';
    } else if (type === 'hStackedBar') {
      type = 'Bar';
    } else if (type === 'stackedBar100') {
      type = '100% Bar';
    } else if (type === 'hStackedBar100') {
      type = '100% Bar';
    } else if (type === 'pie' && chart.view.pie && chart.view.pie.donut) {
      type = 'Donut';
    } else if (type === 'bigNumber') {
      type = 'Big Number';
    } else if (type === 'bigValue') {
      type = 'Big Value';
    } else if (type === 'pivotTable') {
      type = 'Pivot Table';
      suffix = '';
    } else if (type === 'linePlusBar') {
      type = 'Line + Bar';
    } else if (type === 'totalArea') {
      type = 'Area';
    } else if (type === 'table') {
      type = 'Table';
      suffix = '';
    } else if (type === 'vegas') {
      type = 'Visual Explorer';
      suffix = '';
    }

    return getTitle(chart) || (type ? type[0].toUpperCase() + type.slice(1) + ' ' + suffix : suffix);
  }

  export function getVizReportRunLink(chart: ChartTypes.ChartResource, reportRunToken: string) {
    return chart.hasLink('report_run_viz_web')
      ? chart.links('report_run_viz_web').$expand({ token: reportRunToken }, { excludeSSLPort: true })
      : '';
  }

  export function getVizLink(chart: ChartTypes.ChartResource): string | undefined {
    if (chart && chart.hasLink('report_viz_web')) {
      return chart.links('report_viz_web').$expand({}, { excludeSSLPort: true });
    }
  }

  export function getChartIcon(chart: ChartTypes.ChartResource) {
    if (chart.view_version === 1) {
      return CHART_TYPE_ICONS[chart.view.selectedChart] || CHART_TYPE_ICONS['bar'];
    } else {
      return (chart.view_vegas && CHART_TYPE_ICONS[chart.view_vegas.chartType]) || CHART_TYPE_ICONS['bar'];
    }
  }

  export function getDarkChartIcon(chart: ChartTypes.ChartResource) {
    if (chart.view_version === 1) {
      return CHART_TYPE_ICONS_DARK[chart.view.selectedChart] || CHART_TYPE_ICONS_DARK['bar'];
    } else {
      return (chart.view_vegas && CHART_TYPE_ICONS_DARK[chart.view_vegas.chartType]) || CHART_TYPE_ICONS_DARK['bar'];
    }
  }

  export function chartIconFromType(type: ChartTypes.ChartType | ChartTypes.V1ChartType) {
    return CHART_COLOR_ICONS[type] || CHART_COLOR_ICONS['bar'];
  }
}
